import React, { useState, useEffect } from "react";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CloseIcon from "@mui/icons-material/Close";
import {
    Stack,
    IconButton,
    Card,
    CardContent,
    Button,
    Typography,
    CardActions,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    CardHeader,
    Theme,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableRow,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import fileDownload from "js-file-download";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ConfirmDialog from "../../helper/ConfirmDialog";
import dayjs from "dayjs";
import { globalService } from "../../../services/GlobalService";
import { useSharedNavigation } from "../../../utility/context/NavigationContext";
import { Messages } from "../../../utility/Config";
import { AuthContext } from "../../../utility/context/AuthContext";
import { SocietyMemberTenantsService } from "../../../services/SocietyMemberTenantsService";
import { BillAbbreviationWiseDTO, SocietyMemberRequestForMobileDTO } from "../../../models/SocietyMemberTenantsModel";
import { easeBuzzService } from "../../../services/EaseBuzzService";
import { EaseBuzzInitiatePaymentLinkDTO } from "../../../models/EaseBuzzModel";
import Controls from "../../../utility/controls/Controls";
import { SelectListModel } from "../../../models/ApiResponse";
import { societyBillSeriesService } from "../../../services/SocietyBillSeriesService";
import { societyMembersService } from "../../../services/SocietyMembersService";
import useForm from "../../../utility/hooks/UseForm";
import { societyReportService } from "../../../services/SocietyReportService";
import { MemberLedgerReportModel } from "../../../models/SocietyReportModel";
import { societySubscriptionsService } from "../../../services/SocietySubscriptionsService";
import { makeStyles } from "@mui/styles";
import BillView from "../../billing/BillView";
import { json } from "stream/consumers";
import { societyBillsService } from "../../../services/SocietyBillsService";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        border: "0.5px solid grey",
        display: "inline-flex",
        width: "100% !important",
        margin: "0px !important",
    },
    societyName: {
        fontSize: "1rem !important"
    },
    item: {
        border: "0.5px solid grey",
        paddingTop: "2px !important",
    },
    footerCell: {
        // border: '0.5px solid grey',
        fontWeight: "bold !important",
    },
    footerCellAmount: {
        textAlign: "right", // without !important
        fontWeight: "bold", // without !important
        // If absolutely needed:
        "&.MuiTableCell-root": {
            textAlign: "right !important",
            fontWeight: "bold !important",
        },
    },
    tableHead: {
        backgroundColor: "lightgrey !important",
        fontWeight: "bold !important",
    },
}));

function SocietyMemberTenantList() {
    const { auth } = React.useContext(AuthContext);
    const { goToHome } = useSharedNavigation();
    const [societyMemberTenants, setSocietyMemberTenants] = useState([]);
    const [isBillPopupOpen, setIsBillPopupOpen] = useState(false);
    const [societyBill, setSocietyBill] = useState<any>(null);
    const [openLedgerDialog, setOpenLedgerDialog] = useState(false);
    const [enteredAmount, setEnteredAmount] = useState(0);
    const [openPayDialog, setOpenPayDialog] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);
    const [outstandingAmounts, setOutstandingAmounts] = useState([]);
    //const [totalPayAmount, setTotalPayAmount] = useState(0);
    const [billAbbreviations, setBillAbbreviations] = useState<SelectListModel[]>([]);
    const [societySubscriptions, setSocietySubscriptions] = useState<any[]>([]);
    const [societySubscriptionsSelectList, setSocietySubscriptionsSelectList] = useState<SelectListModel[]>([]);
    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        title: "",
        subTitle: "",
        onConfirm: () => { },
    });
    const navigate = useNavigate();
    //const prevPgState = useLocation();
    const handleOpenBillPopup = () => {
        setIsBillPopupOpen(true);
    };

    const handleCloseBillPopup = () => {
        setIsBillPopupOpen(false);
        localStorage.removeItem("societySubscriptionId");
    };

    const handleClosePayPopup = () => {
        setOpenPayDialog(false);
    };

    const getSocietyBillById = (societyBillId: any) => {
        societyBillsService.getById(societyBillId).then((response) => {
            if (response) {

                let result = response.data;
                let bill = result.data;
                localStorage.setItem("societyId", bill.SocietyId);
                setSocietyBill(bill);
                handleOpenBillPopup();
                if (bill)
                    localStorage.setItem("societySubscriptionId", bill.SocietySubscriptionId);
            }
        })
    };

    useEffect(() => {
        getSocietyMemberTenants();
    }, []);

    const validate = (fieldValues: any = values) => {
        let temp: any = { ...errors };
        setErrors({
            ...temp,
        });

        if (fieldValues === values)
            return Object.values(temp).every((x) => x === "");
    };

    const { values, setValues, errors, setErrors, handleInputChange } = useForm(
        societyMembersService.initialForMemberFieldValues,
        validate,
        ''
    );

    const handleOpenLedgerDialog = (row: any) => {
        setSelectedMember(row);
        setOpenLedgerDialog(true);
    };

    const handleCloseLedgerDialog = () => {
        setOpenLedgerDialog(false);
    };

    const downloadLedgerPDF = () => {
        let selSubscription = societySubscriptions.filter(x => x.SocietySubscriptionId == values.SocietySubscriptionId)[0];
        if (!selSubscription) {
            globalService.error('Please select subscription.');
            return;
        }
        var model: MemberLedgerReportModel = {
            SocietyId: selectedMember.SocietyId,
            SocietyMemberId: selectedMember.SocietyMemberId,
            BillAbbreviation: '',
            SocietyBuildingUnitId: selectedMember.societyBuildingUnitId,
            SocietySubscriptionId: selSubscription.SocietySubscriptionId,
            SocietyBuildingId: selectedMember.SocietyBuildingId,
            FromDate: new Date(selSubscription.SubscriptionStart),
            ToDate: new Date(selSubscription.SubscriptionEnd),
            IsDetails: false
        };

        societyReportService.memberLedgerReportPdf(model).then((response) => {
            let result = response.data;
            fileDownload(result, "MemberLedgerReport.pdf");
            handleCloseLedgerDialog();
        });
    };

    const getBillAbbreviationBySocietyId = (societyId: any) => {
        societyBillSeriesService
            .getSelectListBySocietyId(societyId)
            .then((response) => {
                setBillAbbreviations(response.data);
                // if (response.data.length > 0) {
                //   values.BillAbbreviation = response.data[0].Value;
                // }
            });
    };

    const getSocietyMemberTenants = () => {
        let model: SocietyMemberRequestForMobileDTO = {
            MobileNo: auth.MobileNo,
            OTP: '',
            MemberKey: ''
        }
        SocietyMemberTenantsService.getSocietyMemberTenantInfo(model).then(
            (response) => {
                let result = response.data;
                debugger;
                setSocietyMemberTenants(result.list);
            }
        );
    };

    const getBills = (row: any) => {
        // .SocietyId, params.row.societyBuildingUnitId
        localStorage.setItem('societyId', row.SocietyId);
        localStorage.setItem('societyName', row.SocietyName);
        navigate("/societyBills/" + row.SocietyId + "/" + row.societyBuildingUnitId + "/" + row.SocietyMemberId);
    }

    const handlePay = (row: any) => {
        setSelectedMember(row);
        setOpenPayDialog(true);
        let model: BillAbbreviationWiseDTO = {
            SocietyBuildingUnitID: row.societyBuildingUnitId,
            SocietyMemberId: row.SocietyMemberId
        }
        SocietyMemberTenantsService.getMemberFlatBalanceBillAbbreviationWiseForWeb(model).then(
            (response) => {
                let result = response.data;
                result.list.map((billData: any) => ({
                    ...billData,
                    isChecked: false,
                    PayAmount: billData.PayAmount || ''
                }));
                setOutstandingAmounts(result.list);
            }
        );
    }

    const handlePayAmountInputChange = (index: any, value: any) => {
        const updated = [...outstandingAmounts];
        updated[index].PayAmount = value;
        setOutstandingAmounts(updated);
    };

    const handleCheckboxChange = (index: any) => {
        const updated = [...outstandingAmounts];
        updated[index].isChecked = !updated[index].isChecked;
        setOutstandingAmounts(updated);
    };

    const handleEasebuzzPayment = () => {
        debugger;
        let row = selectedMember;
        // Prompt or show input box to get custom amount
        //let enteredAmount = prompt("Enter amount to pay", row.OutstandingAmt?.toString());
        // if (!enteredAmount || isNaN(+enteredAmount) || +enteredAmount <= 0) {
        //     globalService.error("Invalid amount entered");
        //     return;
        // }
        // console.log('billAbbreviation=' + row.BillAbbreviation);
        // if (!row.BillAbbreviation) {
        //     globalService.error('Bill Abbreviation not found for this record.');
        //     return;
        // }
        if (totalPayAmount == 0) {
            globalService.error('Total Check Out amount should be greater than 0.');
            return;
        }
        const mappedData = outstandingAmounts.filter(x => x.isChecked == true).map(item => ({
            BillAbbreviation: item.BillAbbreviation,
            OutStandingAmt: item.PayAmount || 0  // fallback to 0 if undefined
        }));

        let model: EaseBuzzInitiatePaymentLinkDTO = {
            Amount: totalPayAmount,
            BillAbbreviation: '', //row.BillAbbreviation,
            FirstName: row.MemberTenantName,
            Email: row.EmailId,
            Phone: row.MobileNo,
            ProductInfo: "web : " + row.SocietyName,

            SocietyId: row.SocietyId,
            SocietyMemberId: row.SocietyMemberId,
            SocietyBuildingUnitId: row.societyBuildingUnitId,

            SocietyReceiptId: '',
            BalanceBillAbbreviationWise: mappedData
        }
        try {
            easeBuzzService.initiatePaymentLinkForMobile(model).then(
                (response) => {
                    let result = response.data;
                    if (result) {
                        if (result.isSuccess) {
                            console.log(result.paymentLink);
                            window.open(result.paymentLink, "_blank"); // Redirect to Easebuzz payment page
                            handleClosePayPopup();
                        } else {
                            globalService.error("Payment link not received");
                        }
                    }
                }
            );

        } catch (error) {
            globalService.error("Payment initiation failed. " + error);
        }
    };

    const getSocietySubscriptionsBySocietyId = (societyId: any) => {
        societySubscriptionsService.getSocietySubscriptionsForMobile(societyId)
            .then((response) => {
                var result = response.data;
                if (result.isSuccess) {
                    setSocietySubscriptions(result.list);
                    const selectList: SelectListModel[] = result.list.map((item: any) => ({
                        Text: item.AcPeriod,  // or item.Name depending on your API
                        Value: item.SocietySubscriptionId     // or item.Id
                    }));

                    setSocietySubscriptionsSelectList(selectList);
                    setValues((prevValues: any) => ({
                        ...prevValues,
                        SocietySubscriptionId: selectList[0].Value,
                    }));
                    localStorage.removeItem("societySubscriptionId");

                }
                else
                    globalService.error(result.message);
            });
    };

    const totalPayAmount = outstandingAmounts.filter(x => x.isChecked == true).reduce((sum: number, billData: any) => {
        const amount = parseFloat(billData.PayAmount) || 0;
        return sum + amount;
    }, 0);

    const classes = useStyles();
    return (
        <>
            {/* <Stack direction="row" spacing={0} justifyContent="space-between">
                <Typography variant="h5">Society Members</Typography>
            </Stack>  font-size 0.875rem*/}
            {/* <pre>{JSON.stringify(societyMemberTenants, null, 2)}</pre> */}
            <Grid container spacing={3} sx={{ padding: 2 }}>
                {societyMemberTenants?.map((row: any, index: number) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card
                            sx={{
                                borderTop: 0,
                                borderRadius: 1,
                                boxShadow: 3,
                                transition: 'transform 0.2s',
                                '&:hover': {
                                    transform: 'scale(1.02)',
                                },
                            }}
                        >
                            <CardHeader
                                title={
                                    <Typography variant="subtitle1" fontWeight={600}>
                                        {row.SocietyName}
                                    </Typography>
                                }
                                subheader={
                                    <Typography variant="caption" color="text.secondary">
                                        Flat No: {row.Building} {row.Unit}
                                    </Typography>
                                }
                                sx={{
                                    backgroundColor: '#3c120f0d',
                                    paddingBottom: 1,
                                    '& .MuiCardHeader-content': {
                                        overflow: 'hidden',
                                    },
                                    borderBottom: 'none', // <-- Removes the bottom border
                                }}
                            />
                            <CardContent>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" color="text.secondary">
                                            <strong>Member Name:</strong> {row.MemberTenantName}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" color="text.secondary">
                                            <strong>Bill No:</strong> {row.BillNo}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" color="text.secondary">
                                            <strong>Bill Date:</strong> {row.BillDate ? dayjs(row.BillDate).format("DD-MMM-YYYY") : ""}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" color="text.secondary">
                                            <strong>Outstanding Amount:</strong>{' '}
                                            {globalService.formatToIndianCurrencyWithoutSymbol(row.OutstandingAmt ?? 0)}
                                        </Typography>
                                    </Grid>

                                    {/* View Bills button */}
                                    <Grid item xs={12}>
                                        <Button size="small"
                                            disabled={!row.SocietyBillId}
                                            variant="contained"
                                            onClick={() => {
                                                getSocietyBillById(row.SocietyBillId);
                                            }}>View Bill Detail</Button>

                                    </Grid>

                                    {/* Divider after View Bills button */}
                                    <Grid item xs={12}>
                                        <Divider sx={{ my: 0 }} />
                                    </Grid>
                                </Grid>
                            </CardContent>
                            <CardActions sx={{ paddingX: 1, paddingBottom: 1 }}>
                                <Stack direction="row" spacing={1} flexWrap="wrap">

                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => {
                                            getSocietySubscriptionsBySocietyId(row.SocietyId);
                                            handleOpenLedgerDialog(row);
                                        }}
                                    >
                                        Ledger
                                    </Button>
                                    {(row.ShowPayButton && row.EmailId) &&
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={() => handlePay(row)}
                                        >
                                            Pay
                                        </Button>
                                    }

                                    <Button variant="outlined" size="small" onClick={() => getBills(row)}>
                                        More Bills
                                    </Button>
                                </Stack>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>


            <Dialog
                open={openLedgerDialog}
                onClose={handleCloseLedgerDialog}
                fullWidth={true}
                maxWidth="sm"
                aria-labelledby="link-my-society-dialog-title"
            >
                <DialogTitle id="link-my-society-dialog-title">
                    Ledger
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseLedgerDialog}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme: any) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <CardContent>
                        <React.Fragment>
                            <Grid container spacing={3}>
                                <Grid item xs={6} sm={8}>
                                    <Controls.Select
                                        name="SocietySubscriptionId"
                                        label="Society Subscription"
                                        required
                                        showEmptyItem={true}
                                        options={societySubscriptionsSelectList}
                                        value={
                                            societySubscriptionsSelectList.length > 0 ? values.SocietySubscriptionId : ""
                                        }
                                        onChange={(e: any) => {
                                            handleInputChange(e);
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={4}>
                                    <Button
                                        variant="contained"
                                        color="error"
                                        startIcon={<DownloadIcon />}
                                        onClick={() => downloadLedgerPDF()}
                                    >
                                        PDF
                                    </Button>
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    </CardContent>
                </DialogContent>
            </Dialog>

            <Dialog
                open={openPayDialog}
                onClose={handleClosePayPopup}
                fullWidth={true}
                maxWidth="md"
                aria-labelledby="Pay amount"
            >
                <DialogTitle id="Pay Bill">
                    Pay Bill
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClosePayPopup}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme: any) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <CardContent>
                        <React.Fragment>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12}>
                                    <Table
                                        className="tblReceipt"
                                        sx={{
                                            width: "100% !important",
                                            border: "0.5 solid",
                                            display: { xs: "block", md: "table" },
                                            overflowX: "auto",
                                            //whiteSpace: 'nowrap'
                                        }}
                                    >
                                        <TableBody>
                                            <TableRow className={classes.tableHead}>
                                                <TableCell size="small">
                                                    <strong>Select</strong>
                                                </TableCell>
                                                <TableCell size="small">
                                                    <strong>Bill Name</strong>
                                                </TableCell>
                                                <TableCell
                                                    size="small"
                                                    width={150}
                                                    className="muiTableCell-right"
                                                >
                                                    <strong>OutStanding Amount</strong>
                                                </TableCell>
                                                <TableCell
                                                    size="small"
                                                    width={250}
                                                    className="muiTableCell-right"
                                                >
                                                    <strong>Pay Amount</strong>
                                                </TableCell>
                                            </TableRow>

                                            {outstandingAmounts.map((element, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>
                                                        <input
                                                            type="checkbox"
                                                            checked={element.isChecked}
                                                            onChange={() => handleCheckboxChange(index)}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{element.BillName}</TableCell>
                                                    <TableCell className="muiTableCell-right">{globalService.formatToIndianCurrency(element.OutStandingAmt)}</TableCell>
                                                    <TableCell className="muiTableCell-right">
                                                        <Controls.Input
                                                            required
                                                            label="Pay Amount"
                                                            autoComplete="given-name"
                                                            name="PayAmount"
                                                            type="number"
                                                            value={element.PayAmount}
                                                            onChange={(e: any) => handlePayAmountInputChange(index, e.target.value)}
                                                            error={errors.PayAmount}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell
                                                    size="small"
                                                    className={`muiTableCell-right ${classes.footerCell}`}
                                                >
                                                    Total Amount
                                                </TableCell>

                                                <TableCell size="small"
                                                    className={`muiTableCell-right ${classes.footerCellAmount}`}>
                                                    {globalService.formatToIndianCurrency(outstandingAmounts.reduce((sum: number, billData: any) => {
                                                        const amount = parseFloat(billData.OutStandingAmt) || 0;
                                                        return sum + amount;
                                                    }, 0)
                                                    )}
                                                </TableCell>
                                                <TableCell
                                                    size="small"
                                                    className={classes.footerCellAmount}
                                                >
                                                    {globalService.formatToIndianCurrency(totalPayAmount)}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </Grid>
                                <Grid item xs={12} sm={12} sx={{ textAlign: 'right' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<ExitToAppIcon />}
                                        onClick={() => handleEasebuzzPayment()}
                                    >
                                        Check Out {globalService.formatToIndianCurrency(totalPayAmount)}
                                    </Button>
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    </CardContent>
                </DialogContent>
            </Dialog >

            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />

            {
                societyBill && <BillView
                    open={isBillPopupOpen}
                    onClose={handleCloseBillPopup}
                    SocietyBillId={societyBill.SocietyBillId}
                    BillAbbreviation={societyBill.BillAbbreviation}
                    SocietyId={societyBill.SocietyId}
                    SocietySubscriptionId={societyBill.SocietySubscriptionId}
                />
            }
        </>
    );
};

export default SocietyMemberTenantList
